import request from "request";
import { URL_BACKEND } from "./config";

export const getAlfas = (token, filters) => {
    return new Promise((resolve, reject) => {
        request(
            {
                headers: {
                    "Content-Type": "application/json",
                    "User-Token": token,
                },
                uri: URL_BACKEND + "/ficha-tecnica/alfas",
                method: "GET",
                qs: filters,
            },
            (err, res, body) => {
                resolve({ err: err, res: res, body: body });
            }
        );
    });
};

export const getIds = (token, filters) => {
    return new Promise((resolve, reject) => {
        request(
            {
                headers: {
                    "Content-Type": "application/json",
                    "User-Token": token,
                },
                uri: URL_BACKEND + "/qualidade/ficha-tecnica/ids",
                method: "GET",
                qs: filters,
            },
            (err, res, body) => {
                resolve({ err: err, res: res, body: body });
            }
        );
    });
};
